import { useQueryClient } from '@tanstack/react-query';

import { VOUCHER_LIST_KEY } from './useVoucherList';

export const useInvalidateVoucherList = () => {
  const queryClient = useQueryClient();

  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: [VOUCHER_LIST_KEY],
      exact: false,
      refetchType: 'active',
    });
  };

  return { invalidate };
};
